import React from 'react'

const Savecheck = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_281_55)">
<path d="M20.3125 12.1875C19.8611 7.64055 16.707 4.875 13 4.875C9.49609 4.875 7.23938 7.32266 6.5 9.75C3.45312 10.0547 0.8125 11.9636 0.8125 15.4375C0.8125 18.7891 3.55469 21.125 6.90625 21.125H20.1094C22.9023 21.125 25.1875 19.7316 25.1875 16.6562C25.1875 13.6185 22.4961 12.3013 20.3125 12.1875Z" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.75781"></path>
<path d="M16.0977 10.5625L10.6234 17.0625L8.27734 14.4625" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeOpacity="0.5" strokeWidth="1.75781"></path>
</g>
<defs>
<clipPath id="clip0_281_55">
<rect fill="currentColor" height="26" width="26"></rect>
</clipPath>
</defs>
</svg>
    )
}

export default Savecheck
